// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"180":"App","475":"views"}[chunkId] || chunkId) + "." + {"180":"84b58432","475":"9807b558","480":"3581391d","638":"cb0c09da"}[chunkId] + ".chunk.js";
};